export default __webpack_public_path__ + "static/media/svg-5.e2ab353b.svg";